import React from "react";
import { Table, Grid, Dimmer, Loader } from "semantic-ui-react";
import { Link } from "react-router-dom";
import {
  getRequestHeadersService,
  getDepartmentsByUser,
  getWorkSheet
} from "../../services/offpriceServices";
import { css } from 'emotion';
const style = css`
  &.create-cdp-home-color {
    background: #35c9ae14!important;
    color: rgba(0,0,0,.95)!important;
  }`

export default class Home extends React.Component {
  state = {
    loading: true,
    worksheetList: []
  };

  componentDidMount() {
    this.loadWorksheetList();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.worksheetSearchText !== this.props.worksheetSearchText) {
      return this.loadWorksheetList();
    }
  }

  loadWorksheetList() {
    const { worksheetSearchText } = this.props;
    const requestWorksheetData = worksheetSearchText
      ? getWorkSheet
      : getRequestHeadersService;

    this.setState({ loading: true });

    Promise.all([
      requestWorksheetData(worksheetSearchText),
      getDepartmentsByUser()
    ]).then(([worksheet, departments]) => {
      let worksheetData = [];

      if (Array.isArray(worksheet.data)) {
        worksheetData = worksheet.data;
      }

      if (Array.isArray(departments.data) && departments.data.length) {
        worksheetData = worksheetData.filter(({ DeptNo }) =>
          departments.data.includes(DeptNo.toString())
        );
      }

      this.setState({
        loading: false,
        worksheetList: worksheetData
      });
    });
  }

  render() {
    const { loading, worksheetList } = this.state;

    if (loading) {
      return (
        <Dimmer active inverted inline="centered">
          <Loader />
        </Dimmer>
      );
    }

    if (!worksheetList.length) {
      return <div>No results found!</div>;
    }

    return (
      <Grid padded>
        <Grid.Row>
          <Grid.Column width={16}>
            <Table selectable celled>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>WorkSheet</Table.HeaderCell>
                  <Table.HeaderCell>Dept</Table.HeaderCell>
                  <Table.HeaderCell>Vendor</Table.HeaderCell>
                  <Table.HeaderCell>Status</Table.HeaderCell>
                  <Table.HeaderCell>Owner</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {worksheetList.map(
                  ({
                    RequestHeaderId: id,
                    RequestHeaderName: worksheetName,
                    DeptNo,
                    VendorNo,
                    Status,
                    CreatedByDisplayName: owner,
                    WrkSheetTypeId
                  }) => (
                    <Table.Row key={id} className={`${style} ${WrkSheetTypeId == 2 ? " create-cdp-home-color" : ""}  `}>
                      <Table.Cell>
                      { WrkSheetTypeId == 2 ?
                        <Link to={`cdp-products/${id}`}>{worksheetName}</Link>
                        : <Link to={`products/${id}`}>{worksheetName}</Link> } 
                      </Table.Cell>
                      <Table.Cell>{DeptNo}</Table.Cell>
                      <Table.Cell>{VendorNo}</Table.Cell>
                      <Table.Cell>{Status}</Table.Cell>
                      <Table.Cell>{owner}</Table.Cell>
                    </Table.Row>
                  )
                )}
              </Table.Body>
            </Table>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}



// WEBPACK FOOTER //
// ./components/home/Home.js